<template>
  <div class="l-content desktop">
    <div class="text-title">{{mText}}</div>
    <div class="text-subtitle">{{mAuthor}}</div>
  </div>
</template>

<script>
export default {
  name: 'RowQuote',
  data () {
    return {
      mText: '"The higher we are placed, the more humbly we should walk"',
      mAuthor: 'Marcus Tullius Cicero'
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .l-debug {
    border-width: 1px;
    border-color: yellow;
    border-style: dashed;
  }
  .l-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 22rem;
    background-color: #B5390C;
  }
  .l-content .text-title {
    color: #fcfcfc;
    font-weight: lighter;
    font-size: x-large;
  }
  .text-subtitle {
    width: 45%;
    color: #fcfcfc;
    font-weight: normal;
    font-size: large;
    margin-left: auto;
    margin-right: auto;
    margin-top: 24px
  }
  @media screen and (max-width: 768px) {
    .l-content {
      height: 16rem;
    }
    .desktop {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/RowQuote.vue